import Vue from 'vue';
import Router from 'vue-router';
import Hikari from './views/Hikari.vue';
import Mobile from './views/Mobile.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes: [
    {
      path: '/mobile',
      name: 'mobileEntrance',
      beforeEnter: (to, from, next) => {
        const params = new URLSearchParams(location.search);

        let query = {};

        // keep = trueの場合パラメータを追加
        const keepValue = params.get('keep');
        if (keepValue != undefined) {
          query = Object.assign(query, { keep: keepValue });
        }
        next({ replace: true, name: 'mobile', query: query });
      },
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: Mobile,
      meta: {
        title: '最短2分でかんたん！Webでお見積り書作成 | 【公式】法人向け格安SIM/スマホならBIGLOBEモバイル | BIGLOBE biz.',
        // tslint:disable-next-line:max-line-length
        description:
          'BIGLOBEが提供する「法人格安SIM・スマホ」の料金がいくらかかるかシミュレーションし、さらにその内容でお見積り書をその場でWeb上から作成することができます。M2M向け専用の料金プランもお見積りすることが可能です。',
        logo: '法人向け格安SIM・スマホ お見積り',
        canonical: 'https://biz.biglobe.ne.jp/estimate/mobile',
      },
    },
    {
      path: '/hikari',
      name: 'hikari',
      component: Hikari,
      meta: {
        title:
          '料金シミュレーションとお見積り書作成 | 法人向け光回線はBIGLOBE光 | BIGLOBE biz.',
        // tslint:disable-next-line:max-line-length
        description:
          '法人向け「BIGLOBE光」の料金がいくらかかるかシミュレーションし、さらにその内容でお見積り書をその場でWeb上から作成することができます。BIGLOBE光電話の料金もお見積りすることが可能です。',
        logo: 'BIGLOBEの法人向けサービス',
        canonical: 'https://biz.biglobe.ne.jp/estimate/hikari',
      },
    },
    {
      path: '*',
      beforeEnter: (to, from, next) => {
        window.location.href = 'https://biz.biglobe.ne.jp/notfound.html';
      },
    },
  ],
});
